import { render, staticRenderFns } from "./LocaleLogin.vue?vue&type=template&id=ae32a2e2&"
import script from "./LocaleLogin.vue?vue&type=script&lang=js&"
export * from "./LocaleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports